<template>
  <div class="page" id="page-contents">
    <div class="section event" id="section-contents-landing">
      <div class="container">
        <div class="header">
          <img alt="로고" src="/static/carousel-icon.png" />
          <p>make sure your sure</p>
        </div>
        <div class="body">
          <h3>인슈넷 FC의 다양한 콘텐츠 정보를 확인해보세요.</h3>
        </div>
      </div>
    </div>

    <div class="section" id="section-contents-items">
      <div class="container">
        <div class="section-title">
          <p>EVENTS</p>
        </div>

        <div class="section-header">
          <div class="container">
            <element-tab>
              <element-tab-item
                class="element-tab-item"
                v-for="(tab, index) in tabs"
                :key="index"
                :class="activeTab === tab ? 'active' : ''"
                @click="() => changeTabEvent(tab)"
              >
                {{ tab }}
              </element-tab-item>
            </element-tab>
          </div>
        </div>

        <div class="section-body">
          <div class="container">
            <el-row :gutter="20" v-if="!events.length">
              <el-col :span="24" style="padding: 2rem">
                데이터가 없습니다.
              </el-col>
            </el-row>
            
            <el-row :gutter="20">
              <el-col
                v-for="(item, index) in events"
                :sm="8"
                :xs="12"
                :key="index"
              >
                <el-card shadow="hover">
                  <div
                    class="html-content"
                    v-html="item.content"
                    @click="event => moveToDetail(event, item)"
                  />

                  <div style="padding: 1rem" @click="event => moveToDetail(event, item)">
                    <el-row>
                      <el-col :span="10" class="left-content">
                        <span>{{ moment(item.createdAt).format('YYYY-MM-DD') }}</span>
                        <div class="bottom">
                          <p>견적신청 수 <span class="font-blue">{{ (item.estimate_requests || 0).toLocaleString() }}</span></p>
                          <p>조회수 <span class="font-blue">{{ (item.views || 0).toLocaleString() }}</span></p>
                        </div>
                      </el-col>
                      <el-col :span="14" class="right-content link" v-if="item.document_extra">                        
                        <el-button
                          v-for="(link, index) in item.document_extra.links"
                          :key="index"
                          size="mini"
                          class="link-btn link"
                          @click="(event) => moveToURL(event, link.url)"
                          circle
                        >
                          <img :src="`/static/contents/${link.linkType}.png`" :alt="link.linkType" class="link"/>
                        </el-button>
                      </el-col>
                      <!-- <el-col :span="8" class="right-content">
                        <button type="text">
                          <img src="/static/contents/icon-share.png" alt="링크 공유" />
                        </button>
                        <button type="text">
                          <img src="/static/contents/icon-heart.png" alt="좋아요" />
                        </button>
                      </el-col> -->
                    </el-row>
                  </div>
                </el-card>

                <el-button
                  type="primary"
                  class="submit-btn"
                  @click="moveToCompareEstimate(item)"
                  round
                >비교견적 신청하기</el-button>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="my-2" v-if="events.length">
              <el-col
                :span="12"
                :offset="6"
                class="pagination"
              >
                <el-button
                  type="text"
                  icon="el-icon-d-arrow-left"
                  class="first-btn"
                  @click="moveToFirstPage"
                ></el-button>
                <el-pagination
                  :page-size="9"
                  :pager-count="11"
                  layout="prev, pager, next"
                  :total="total"
                  :current-page="page"
                  @current-change="updateContents"
                ></el-pagination>
                <el-button
                  type="text"
                  icon="el-icon-d-arrow-right"
                  class="last-btn"
                  @click="moveToLastPage"
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
import { Row, Col, Card, Button, Pagination } from 'element-ui';
import moment from 'moment';
import Footer from "../../view/layout/Footer.vue";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Card.name]: Card,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    Footer,
  },
  data() {
    return {
      events: [],
      tabs: ['전체', '진행중', '종료'],
      activeTab: '전체',
      moment,
      page: 1,
      size: 9,
      category: '',
      total: 0
    }
  },
  mounted() {
    this.getContents();
  },
  methods: {
    getContents() {
      let params = {
        page: this.page,
        size: this.size,
        document_type: '이벤트',
      };

      if (this.activeTab !== '전체') {
        params.event_status = this.activeTab;
      }

      this.$store.dispatch('etc/getContents', params).then(res => {
        const { data } = res.data;
        const { items } = data;

        this.events = items.map(item => ({
          ...item,
          document_extra: JSON.parse(item.document_extra || '{}')
        }));
      });
    },
    changeTabEvent(tab) {
      this.activeTab = tab;

      // this.total = total[0] * 1;
      this.page = 1;
      this.size = 9;
      this.getContents();
    },
    updateContents(page) {
      this.page = page;

      const params = {
        page: this.page,
        data_category: this.category
      };

      this.$store.dispatch('etc/getContents', params).then(res => {
        const { data } = res.data;
        const { items } = data;
        
        this.events = items;
        document.body.scrollTop = 0;
      });
    },
    moveToFirstPage() {
      this.updateContents(1);
    },
    moveToLastPage() {
      const page = Math.ceil(this.total / 9);
      this.updateContents(page);
    },
    moveToDetail(event, { _id }) {
      if (event.target.className.indexOf('link') !== -1) {
        return;
      }
      
      this.$router.push({
        name: 'EventDetail',
        path: 'event',
        query: { id: _id }
      });
    },
    moveToCompareEstimate({ _id, document_category, estimate_requests, views }) {
      const component = {
        '자동차': { name: 'CarInsurance' },
        '운전자': { name: 'CompareEstimate', query: { tab: '운전자보험' } },
        '실손': { name: 'EstimateLosslessMedicalInsurance' },
        '암': { name: 'CancerInsurance' },
        '어린이': { name: 'ChildInsurance' },
        '태아': { name: 'FetalInsurance' },
        '정기': { name: 'TermInsurance' },
        '종신': { name: 'WholeLifeInsurance' },
        '화재': { name: 'FireInsurance' },
        '연금': { name: 'PensionInsurance' },
        '치아': { name: 'DentalInsurance' },
        '치매': { name: 'DementiaInsurance' },
        '펫': { name: 'PetInsurance'}
      }[document_category] || { name: 'Home' };

      this.$store.dispatch('etc/updateContent', {
        id: _id,
        data: {
          estimate_requests: (estimate_requests * 1) + 1,
          views: (views * 1) + 1
        }
      });

      this.$router.push(component);
    },
    moveToURL(event, url) {
      event.preventDefault();
      window.open(url);
    }
  }
}
</script>

<style lang="scss" scoped>
.link-btn {
  position: relative;
  display: inline-flex;
  margin: 4px 8px;
  margin-top: 4px !important;
  width: 28px !important;
  height: 28px;
  border-radius: 100%;
  overflow: hidden;
  background: #fff;
  border: 1px solid #bfbfbf;
  padding: 2px;
  box-sizing: content-box;
  cursor: pointer;

  img {
    width: 28px;
    height: 28px;
    border-radius: 100%;
    display: inline-flex;
    font-size: 28px;
  }
}
</style>